<script setup lang="ts">
import { deleteUserAddress } from '@caks/shared/api/user.route'
import { CommonTitle } from '../common'
import { ButtonMain } from '@caks/uikit/button'
import { IconCross } from '@caks/uikit/icon'

interface Props {
  addresses: any
}
interface Emit {
  (emit: 'add-new-address'): void
  (emit: 'delete-address', id: number): void
}

const emit = defineEmits<Emit>()
defineProps<Props>()

const getStreetString = (street: string, house: string, apartment: string) => {
  return `${street}, ${house}, кв. ${apartment}`
}

const deleteAddress = async (id: number) => {
  await deleteUserAddress(id)

  emit('delete-address', id)
}
</script>

<template>
  <div class="addresses">
    <common-title title="Адреса доставки" />
    <ul class="addresses__list">
      <transition-group name="payment">
        <li v-for="item in addresses" :key="item.id" class="address">
          <p class="address__street">
            {{ getStreetString(item.street, item.house_number, item.apartment) }}
            <button @click="deleteAddress(item.id)">
              <icon-cross />
            </button>
          </p>
          <p class="address__comment">{{ item.comment }}</p>
        </li>
      </transition-group>
    </ul>
    <button-main :button-state="5" @click="emit('add-new-address')"> Добавить адрес </button-main>
  </div>
</template>

<style scoped lang="scss">
.addresses {
  display: flex;
  flex-direction: column;
  gap: 32px;
  max-width: 416px;

  &__list {
    display: flex;
    flex-direction: column;
    gap: 32px;

    .address {
      display: flex;
      flex-direction: column;
      gap: 16px;

      &__street {
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: $primary-text;
        @include h3-5;
      }

      &__comment {
        color: $sub-text;
        @include h5-2;
      }
    }
  }
}

.payment-leave-active {
  transition: all 0.2s ease;
}
.payment-enter-from,
.payment-leave-to {
  opacity: 0;
  transform: translateX(-99%);
}
</style>
